import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom'
import Breadcrumb from '../common/breadcrumb';
//import data from '../../assets/data/listUser';
import Datatable_user from '../common/datatable_user_session'

export class User_List_user extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            user: [],
            sessionList: [],
            viewMode: "USER"
        };
    }

    componentDidMount() {
        if (!localStorage.getItem('userInfo')) {
            window.location.href = '/admin';
        }

        fetch(`${process.env['REACT_APP_HOST']}/api/users/user_list/`)
            .then((response) => response.json())
            .then(result => {
                this.setState({ user: result });
            });
            
    }
    changeMode = (_id) => {
        this.setState({ sessionList: [], viewMode: "SESSION" })
        fetch(`${process.env['REACT_APP_HOST']}/api/users/user_session/${_id}`)
            .then((response) => response.json())
            .then(result => {
                this.setState({ sessionList: result });
            });
    }
    goBack = () => {
        this.setState({ viewMode: "USER" })
    }

    render() {

        return (
            <Fragment>
                <Breadcrumb title="User Session" parent="Users" />
                {this.state.viewMode == "USER" ?
                    <div className="container-fluid">
                        <div className="card">
                            {/* <div className="card-header">
                                 <h5>User Details</h5> 
                            </div>*/}
                            <div className="card-body">

                                <div className="clearfix"></div>
                                <div id="batchDelete" className="category-table user-list order-table coupon-list-delete">
                                    <Datatable_user
                                        multiSelectOption={false}
                                        myData={this.state.user}
                                        pageSize={10}
                                        pagination={true}
                                        class="-striped -highlight"
                                        changeMode={this.changeMode}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">
                                <h5>User Details</h5>
                            </div>
                            <div className="card-body">
                                <div className="btn-popup pull-right">
                                    <button onClick={this.goBack} className="btn btn-secondary">Back</button>
                                </div>
                                <div className="clearfix"></div>
                                <div id="batchDelete" className="category-table user-list order-table coupon-list-delete">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col">S.No</th>
                                                <th scope="col">Loged in Time</th>
                                                <th scope="col">Loged out Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.sessionList.map((list, index) => {
                                                let s_date = new Date(list.createdAt);
                                                let e_date = new Date(list.updatedAt);
                                                return (
                                                    <tr>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{`${s_date.getDate()}/${s_date.getMonth() + 1}/${s_date.getFullYear()}, ${s_date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}  `}</td>
                                                        <td>{list.isActive == false ? `${e_date.getDate()}/${e_date.getMonth() + 1}/${e_date.getFullYear()}, ${e_date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}  ` : " - "}</td>

                                                    </tr>)
                                            }
                                            )}


                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </Fragment>
        )
    }
}

export default User_List_user
